
export const IS_PRODUCTION = process.env.NODE_ENV === 'production'
export const HTTP_STATUS = {
  badRequest: 400,
  unauthrized: 401,
  unprocessableEntity: 422
}

export const HTTP_HEADER_SKIP_ERROR = 'Dream-Skip-Error'

export const REPORT_LINK = process.env.VUE_APP_REPORT_LINK || 'https://staging-solomon.beusable.net/report'
export const HEATMAP_REPORT_LINK = process.env.VUE_APP_HEATMAP_REPORT_LINK || 'https://staging-solomon.beusable.net/heatmap'
export const HEATMAP_REPORT_OLD_LINK = process.env.VUE_APP_HEATMAP_REPORT_OLD_LINK || 'https://staging-solomon.beusable.net/scroll'
export const SOLOMON_REPORT = process.env.VUE_APP_SOLOMON_REPORT_URL || 'https://staging-solomon.beusable.net'

export const AUTH_COOKIE = {
  name: 'beu_auth',
  expires: 365,
  path: '/'
}

export const UI_TYPE_COOKIE = {
  name: 'ui_type',
  expires: 365,
  path: '/'
}

export const LOCALE_COOKIE = {
  name: 'locale',
  expires: 365,
  path: '/'
}

export const TOKEN_COOKIE = {
  name: '_beu_a_t_',
  path: '/'
}

export const LOGIN_CHECK_COOKIE = {
  name: '_beu_heatmap_login',
  path: '/'
}

export const LOGIN_FIRST_COOKIE = {
  name: '_beu_heatmap_first_login',
  path: '/'
}

export const BA_LOGIN_CHECK_COOKIE = {
  name: '_beu_journey_login',
  path: '/'
}

export const BEU_HOST_USER_COOKIE = {
  name: '_beu_host_user_open',
  path: '/'
}

if (IS_PRODUCTION) {
  AUTH_COOKIE.domain = '.beusable.net'
  UI_TYPE_COOKIE.domain = '.beusable.net'
  LOCALE_COOKIE.domain = '.beusable.net'
  TOKEN_COOKIE.domain = '.beusable.net'
  LOGIN_CHECK_COOKIE.domain = '.beusable.net'
  LOGIN_FIRST_COOKIE.domain = '.beusable.net'
  BA_LOGIN_CHECK_COOKIE.domain = '.beusable.net'
  BEU_HOST_USER_COOKIE.domain = '.beusable.net'
}

export const CDN_HOST = 'https://dream-cdn.beusable.net'
export const DOCUMENT_TITLE_PREFIX = 'Beusable'
export const OLD_BEUSABLE_HOST = IS_PRODUCTION ? 'https://www.beusable.net' : 'http://localhost:3000'

export const UTM_TAGS = ['source', 'medium', 'campaign', 'term', 'content']
export const NEW_MOBILE_HEATMAP_STARTDATE = '2020-10-05'

export const NEW_CODE_DEPLOY_DATE = process.env.VUE_APP_NEW_CODE_DEPLOY_DATE || '2022-08-04'
export const NEW_CODE_INFO_LINK = process.env.VUE_APP_NEW_CODE_INFO_LINK || 'https://forum.beusable.net/ko/post/871'

export const SIGNIN_LINK = process.env.VUE_APP_SIGNIN_LINK || 'https://staging-new-home.beusable.net/signin'

export const REPORT_STATE = {
  RUN: 'run',
  STOP: 'stop',
  ERROR: 'error',
  SCHEDULEDRUN: 'scheduledRun',
  ENDBYPVLIMIT: 'endByPvLimit',
  ENDBYANALYSISDATE: 'endByAnalysisDate'
}

export const DEFAULT_TIMEZONE = '+09:00'
export const DEFAULT_TIMEZONE_NAME = 'Asia/Seoul'

export const DEVICE_DESCKTOP = 'desktop'
export const DEVICE_TABLET = 'tablet'
export const DEVICE_PHONE = 'phone'
export const DESKTOP_SCROLL_HEIGHT = 4410
export const MOBILE_SCROLL_HEIGHT = 3217

export const FREQUENCY_HEIGHT = 40
export const FREQUENCY_PV_RANGE = {
  0: -1,
  1: [21, 50],
  2: [11, 20],
  3: [6, 10],
  4: [2, 5],
  5: 1
}

export const FREQUENCY_SESSION_RANGE = {
  0: -1,
  1: [16, 30],
  2: [11, 15],
  3: [6, 10],
  4: [2, 5],
  5: 1
}

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

export const DEVICE_LIST = [
  {
    text: 'Desktop',
    value: 'desktop'
  },
  {
    text: 'Tablet',
    value: 'tablet'
  },
  {
    text: 'Phone',
    value: 'phone'
  }
]

export const REPORT_DETAIL_DATA = [
  // { name: 'type', title: '종류', letterType: 'upper' },
  { name: 'pageName', title: '페이지명', letterType: '' },
  { name: 'url', title: 'URL', letterType: '' },
  { name: 'text', title: 'Text', letterType: '' },
  { name: 'period', title: '기간', letterType: '' },
  { name: 'device', title: '기기', letterType: 'upper' }
]

export const REPORT_MORE_DATA = [
  { name: 'url', title: 'URL', letterType: '' },
  { name: 'text', title: 'Text', letterType: '' },
  { name: 'period', title: '기간', letterType: '' },
  { name: 'utm', title: '마케팅', letterType: 'upper' },
  { name: 'device', title: '기기', letterType: 'upper' },
  { name: 'refer', title: '유입경로', letterType: '' },
  { name: 'existing', title: '방문 타입', letterType: 'upper' },
  { name: 'hour', title: '시간대', letterType: '' },
  { name: 'freq', title: '빈도', letterType: '' },
  { name: 'ctaDom', title: 'ctaDom', letterType: '' }
]

export const REPORT_TIMEMACHINE_DATA = [
  { name: 'url', title: 'URL', letterType: '' },
  { name: 'period', title: '분석 시간', letterType: '' },
  { name: 'device', title: '기기', letterType: 'upper' },
  { name: 'refer', title: '유입경로', letterType: '' },
  { name: 'existing', title: '방문 타입', letterType: 'upper' }
]

export const JAM_BASKET_LIST_STATE = {
  MOVE_TO_BASKET: { value: 'MOVE_TO_BASKET', type: 'add' },
  MOVE_TO_MY_JAM: { value: 'MOVE_TO_MY_JAM', type: 'subtract' },
  CX_HEATMAP: { value: 'CX_HEATMAP', type: 'subtract' },
  JAM_EXPIRED: { value: 'JAM_EXPIRED', type: 'subtract' }
}

export const JAM_LIST_STATE = {
  JAM_CHARGE: {
    value: 'JAM_CHARGE',
    type: 'add'
  },
  REWARD: {
    value: 'REWARD',
    type: 'add'
  },
  MOVE_TO_BASKET: {
    value: 'MOVE_TO_BASKET',
    type: 'subtract'
  },
  MOVE_TO_MY_JAM: {
    value: 'MOVE_TO_MY_JAM',
    type: 'add'
  },
  PV_CHARGE: {
    value: 'PV_CHARGE',
    type: 'subtract'
  },
  BUY_REPORT: {
    value: ['BUY_REPORT_PREFIX', 'BUY_REPORT_INDEPTH', 'BUY_REPORT_PERIOD', 'BUY_REPORT_SEGMENT', 'BUY_REPORT_SCROLL', 'BUY_REPORT_DASHBOARD', 'BUY_REPORT_DASHBOARD_HELL'],
    type: 'subtract'
  },
  CANCEL_REPORT: {
    value: ['CANCEL_REPORT_PREFIX', 'CANCEL_REPORT_SEGMENT', 'CANCEL_REPORT_PERIOD', 'CANCEL_REPORT_INDEPTH'],
    type: 'add'
  },
  JAM_EXPIRED: {
    value: 'JAM_EXPIRED',
    type: 'subtract'
  }
}

export const JAM_PAYMENT_LIST_STATE = {
  JAM_CHARGE: 'JAM_CHARGE',
  JAM_EXPIRED: 'JAM_EXPIRED',
  MOVE_TO_BASKET: 'MOVE_TO_BASKET',
  MOVE_TO_MY_JAM: 'MOVE_TO_MY_JAM',
  PV_CHARGE: 'PV_CHARGE',
  BUY_REPORT_PREFIX: 'BUY_REPORT_PREFIX',
  BUY_REPORT_INDEPTH: 'BUY_REPORT_INDEPTH',
  BUY_REPORT_PERIOD: 'BUY_REPORT_PERIOD',
  BUY_REPORT_SEGMENT: 'BUY_REPORT_SEGMENT',
  BUY_REPORT_SCROLL: 'BUY_REPORT_SCROLL',
  PAYMENT_4GRIT: '4grit',
  PAYMENT_WIRE: 'WIRE',
  PAYMENT_CARD: 'CARD',
  PAYMENT_NONE: 'PAYMENT_NONE',
  CX_HEATMAP: 'CX_HEATMAP',
  CANCEL_REPORT_PREFIX: 'CANCEL_REPORT_PREFIX',
  CANCEL_REPORT_INDEPTH: 'CANCEL_REPORT_INDEPTH',
  CANCEL_REPORT_PERIOD: 'CANCEL_REPORT_PERIOD',
  CANCEL_REPORT_SEGMENT: 'CANCEL_REPORT_SEGMENT',
  BUY_REPORT_DASHBOARD: 'BUY_REPORT_DASHBOARD',
  BUY_REPORT_DASHBOARD_HELL: 'BUY_REPORT_DASHBOARD_HELL',
  REWARD: 'REWARD'
}

export const PAYMENT_LIST_STATE = {
  PAYMENT_CARD: 'CARD',
  PAYMENT_WIRE: 'WIRE',
  PAYMENT_4GRIT: '4grit',
  PAYMENT_NONE: 'PAYMENT_NONE'
}

export const JAM_SERVICE_LIST_STATE = {

}

export const LOCALE_LIST = [
  {
    code: 'ko',
    title: 'Korean'
  },
  {
    code: 'en',
    title: 'English'
  },
  {
    code: 'ja',
    title: 'Japanese'
  }
]
